<header class="sa-layout__header">
  <app-system-admin-header></app-system-admin-header>
</header>
<main class="sa-layout__main container">
  <router-outlet></router-outlet>
</main>
<footer class="sa-layout__footer">
  <app-footer ngClass="container"></app-footer>
</footer>
